import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Alert,
} from '@mui/material'
import { t } from '@lingui/macro'
import type { MaternityAttendanceRow } from '@/core/api/statistics'
import { TRIMESTERS, getTrimesterLabel, pivotMaternityAttendance } from '../../lib/monthlyReportHelpers'

type Props = {
  data?: MaternityAttendanceRow[]
  isLoading: boolean
  error?: unknown
  multiEstablishment: boolean
}

export function TrimesterTable({ data, isLoading, error, multiEstablishment }: Props) {
  if (isLoading) return <CircularProgress size={24} />
  if (error) return <Alert severity="error">{t`Error loading trimester data`}</Alert>
  if (!data || data.length === 0) return <Typography color="text.secondary">{t`No data available`}</Typography>

  const rows = pivotMaternityAttendance(data)
  const trimesterTotals: Record<string, number> = {}
  let grandTotal = 0
  for (const row of rows) {
    for (const tr of TRIMESTERS) {
      trimesterTotals[tr] = (trimesterTotals[tr] || 0) + (row.trimesterCounts[tr] || 0)
    }
    grandTotal += row.total
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: 'primary.main' }}>
            {multiEstablishment && (
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t`Location`}</TableCell>
            )}
            {TRIMESTERS.map(tr => (
              <TableCell key={tr} align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
                {getTrimesterLabel(tr)}
              </TableCell>
            ))}
            <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>{t`Total`}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.establishmentName} hover>
              {multiEstablishment && (
                <TableCell sx={{ fontWeight: 500 }}>{row.establishmentName}</TableCell>
              )}
              {TRIMESTERS.map(tr => (
                <TableCell key={tr} align="center">{row.trimesterCounts[tr] || 0}</TableCell>
              ))}
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>{row.total}</TableCell>
            </TableRow>
          ))}
          {multiEstablishment && (
            <TableRow sx={{ backgroundColor: 'action.hover' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>{t`Total`}</TableCell>
              {TRIMESTERS.map(tr => (
                <TableCell key={tr} align="center" sx={{ fontWeight: 'bold' }}>{trimesterTotals[tr] || 0}</TableCell>
              ))}
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>{grandTotal}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
